<template>
  <Modal title="再次入职" v-model="visible" width="415" class="my-modal top" :mask-closable="false" :footer-hide="true">
    <Form ref="form" :model="formData" class="page-form" :label-width="75">
      <FormItem prop="resignTime" label="入职日期" class="full" :rules="$units.formRule.objRequired('请选择')">
        <DatePicker type="date" v-model="formData.resignTime" format="yyyy-MM-dd" placeholder="请选择入职日期" :transfer="true"></DatePicker>
      </FormItem>
      
      <FormItem label="推荐人" class="full">
        <Select v-model="formData.userId" transfer filterable clearable placeholder="请选择推荐人">
            <Option v-for="item in userList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </FormItem>
    </Form>
    <div class="ivu-modal-footer">
      <Button type="text" @click="visible=false">取消</Button>
      <Button type="primary" @click="save" :loading="loading">确认</Button>
    </div>
  </Modal>
</template>

<script>
export default {
  data() {
    return {
      visible:false,
      loading:false,
      formData:{},
      userList:[]
    };
  },
  
  methods: {
    save(){
      return
      this.$refs.form.validate().then(isok=>{
        if(!isok){
          return;
        }
        const formData = JSON.parse(JSON.stringify(this.formData));
        formData.resignTime = this.$units.formatDate(formData.resignTime);
        this.$http({
          url: "",
          type: "post",
          data: formData
        }).then(res=>{
          this.visible = false;
          this.$notice.success("操作成功")
          this.$emit("success")
        })        
      })
    },
    open(data){
      this.visible = true;
      this.$refs.form&&this.$refs.form.resetFields();
      this.getUserList();
    },
    // 获取当前推荐人
    getUserList(){
      this.$http({
        url: '/buz/entryUserAuth/getByOrgIds',
        type: 'post',
        data: {
          registerId:this.formData.orgId,
        },
      }).then((res) => {
        this.userList = res.data;
      })
    },
  }
};
</script>
<style lang="scss" scoped>
.my-modal {
  .info-text {
    font-size: 12px;
    color: #A8ADB7;
    line-height: 1.5;
    padding-top: 7px;
  }
  .password-icon {
    position: absolute;
    transform: translateX(-30px);
  }
  img.password-icon {
    width: 16px;
    top: 8px;
  }
  .ivu-icon-ios-eye {
    font-size: 18px;
    color: #A8ADB7;
    top: 7px;
  }
  .inherit {
    font-size: 14px;
    color: #515C6F;
  }
  .tip-icon {
      width: 15px;
      height: 15px;
      border-radius: 15px;
      background: transparent;
      border: 1px solid #ccc;
      color: #9b9fa7;
      display: inline-block;
      text-align: center;
      line-height: 14px;
      font-size: 14px;
      cursor: pointer;
      top: 50%;
      margin-top: 7px;
    }
    .tip-icon:hover + .pop-tip {
      opacity: 0.9;
      z-index: 1;
      display: block;
    }
    .pop-tip {
      position: absolute;
      top: 30px;
      left: 100px;
      width: 225px;
      padding: 0px 10px;
      display: flex;
      justify-content: center;
      flex-direction: column;
      background-color: #444444;
      display: none;
      border-radius: 4px;
      span {
        font-size: 12px;
        font-weight: 500;
        color: #fff;
      }
      .arrow {
        position: absolute;
        width: 12px;
        height: 12px;
        background-color: #444444;
        opacity: 0.9;
        top: -4px;
        left: 36%;
        margin-left: -6px;
        transform: rotateZ(135deg);
      }
    }
}
</style>